import { useAthlete } from '@/api/hooks'
import { useDismissPartnerMessage, usePartnerMessages } from '@/api/partnerMessageHooks'
import { useOwnsAthlete } from '@/api/useOwnsAthlete'
import { ShoutTicker } from './ShoutTicker'

/** The sender's first name, or a stand-in when the directory has no name. */
export function shoutSender(name: string | undefined): string {
  return name?.split(' ')[0] || 'Partner'
}

/**
 * The newest partner shout for the viewer's own athlete, as a ticker under the top bar on
 * Today. Nothing when there is none, or when the viewer is looking at someone else.
 */
export function TodayShout({ slug }: { slug: string }) {
  const { athlete } = useAthlete(slug)
  const own = useOwnsAthlete(athlete?.id)
  const query = usePartnerMessages(athlete?.id, own)
  const dismiss = useDismissPartnerMessage(athlete?.id)
  const message = own ? query.data?.received[0] : undefined
  if (!message) return null
  const sender = query.data?.partners.find((p) => p.athleteId === message.senderAthleteId)
  return (
    <ShoutTicker
      key={`${message.senderAthleteId}:${message.createdAt}`}
      body={message.body}
      from={`From ${shoutSender(sender?.name)}`}
      short={shoutSender(sender?.name)}
      onDismiss={() => dismiss.mutate({ senderId: message.senderAthleteId })}
    />
  )
}
